// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar';

export const Component = () => (
  <path d='M18.63 2.963h4.933c.24 0 .48.096.67.288a.946.946 0 0 1 .288.67v19.636c0 .24-.096.479-.287.67a.946.946 0 0 1-.67.288H.957a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V3.921c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.288H5.89V1h.957v1.963h10.824V1h.958v1.963ZM.958 23.557h22.605V8.854H.958v14.703Zm0-15.709h22.605V3.921H.958v3.927Zm12.74 3.927h1.963v1.963h-1.963v-1.963Zm4.932 0h1.964v1.963H18.63v-1.963ZM3.927 16.709h1.964v1.963H3.927v-1.963Zm4.933 0h1.963v1.963H8.86v-1.963Zm4.885 0h1.964v1.963h-1.964v-1.963Zm-9.818-4.886h1.964v1.964H3.927v-1.964Zm4.933 0h1.963v1.964H8.86v-1.964Z' />
);

export const viewBox = '0 0 25 25';
